/**
 * Returns true if received parameter not null
 * @param x
 * @returns
 *
 * @example
 * // given
 * const x = [1, null, 3, undefined]
 * const nulls = [undefined, null]
 * // when
 * x.filter(isNotNull)    // [1, 3]
 * x.some(isNotNull)      // true
 * nulls.some(isNotNull)  // false
 * x.every(isNotNull)     // false
 * nulls.every(isNotNull) // false
 */
export const isNotNull = (...items: any[]) => items.every(x => x != null);
/**
 * Returns true if received parameter null
 * @param x
 * @returns
 *
 * @example
 * // given
 * const x = [1,null,3,undefined]
 * const nulls = [undefined,null]
 * // when
 * x.filter(isNull)    // [undefined,null]
 * nulls.some(isNull)  // true
 * nulls.every(isNull) // true
 * x.some(isNull)      // true
 * x.every(isNull)     // false
 */
export const isNull = (...items: any[]) => items.every(x => x == null);
